import { HttpClient } from '@angular/common/http';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { Subscription, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AdminUrlBuilder } from '../../../../../../../shared/admin/api/admin-url-builder';
import { AbstractListComponent } from '../../../../../../../shared/crud/component/list.component';
import { IPagination } from '../../../../../../../shared/crud/list/pagination.interface';
import { AdminPrintCreditFormModal } from '../../../modals/print-credit-form/print-credit-form.component';

@Component({
    selector: 'print-credit-list-datatable',
    templateUrl: './print-credit-list-datatable.component.html',
    styleUrls: ['./print-credit-list-datatable.component.scss'],
})
export class AdminPrintCreditListDatatableComponent
    extends AbstractListComponent
    implements OnChanges, OnInit, OnDestroy {

    @Input() selectedCampaign!: number | null;
    @ViewChild('qrModal', { static: false }) qrModal: ModalDirective;

    modalRef: BsModalRef;
    updateEventSubscription: Subscription;
    editPrintCreditEventSubscription: Subscription;
    currentQrCode: string = '';

    constructor(
        httpClient: HttpClient,
        toastrService: ToastrService,
        router: Router,
        route: ActivatedRoute,
        urlBuilder: AdminUrlBuilder,
        private modalService: BsModalService
    ) {
        super(httpClient, toastrService, router, route, urlBuilder);
    }

    ngOnInit(): void {
        super.ngOnInit();
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        if (this.editPrintCreditEventSubscription) {
            this.editPrintCreditEventSubscription.unsubscribe();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['selectedCampaign']) {
            this.parameters.offset = 0;
            this.refreshData();
        }
    }

    refreshData() {
        if (this.selectedCampaign === null) return;

        this.parameters.conditions = { campaign: this.selectedCampaign };
        if (this.selectedCampaign === 0) {
            this.parameters.conditions = {};
        }
        this.httpClient
            .get<any>(this.buildUrl(), { params: this.parameters.toStringParams() })
            .pipe(
                map((response: any) => {
                    this.pagination = <IPagination>response;
                    return response;
                }),
                catchError((error: any) => {
                    this.toastrService.error(error.error ? error.error.message || 'Something went wrong...' : 'Error');
                    return throwError(error);
                })
            )
            .subscribe();
    }

    getResourceUrl(): string {
        return '/print-credit';
    }

    onEdit(row): void {
        this.modalRef = this.modalService.show(AdminPrintCreditFormModal, {
            initialState: { record: row },
        });

        this.editPrintCreditEventSubscription = this.modalRef.content.onPrintCreditSaved.subscribe((result: number) => {
            this.load();
        });
    }

    showQrCode(qrCode: string) {
        this.currentQrCode = qrCode;
        this.qrModal.show();
    }

    hideQrCode() {
        this.currentQrCode = '';
        this.qrModal.hide();
    }

    parseLabel(language: string, itemName: string): string {
        try {
            const parsedLabel = JSON.parse(itemName);
            let label: string;
            if (parsedLabel[language]) {
                label = parsedLabel[language];
            } else if (parsedLabel.en) {
                label = parsedLabel.en;
            } else {
                label = parsedLabel[Object.keys(parsedLabel)[0]];
            }
            return label;
        } catch (e) {
            return itemName;
        }
    }
}
